/* ============================================================================
   gaela-hilo.js — la coreografía de la home (D-049, D-050).

   Cero dependencias. Solo se escriben transform, opacity, width y height
   (Regla 9). Todo el contenido está en el HTML servido: este archivo COLOCA,
   nunca crea texto ni datos (Regla 12).

   Si prefers-reduced-motion está activo, el módulo no arranca: el CSS ya
   entrega la página entera apilada y quieta.
   ========================================================================= */
(function () {
  'use strict';

  var REDUCE = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Bisagras del recorrido. Dos iguales seguidas = meseta: la escena se queda
     quieta mientras dura el acto 3 y el gesto lateral recorre los productos. */
  var BISAGRAS = [0.06, 0.20, 0.40, 0.62, 0.80, 0.93];

  var GOTA_MOVIL_ON = 124;   // la bolita que manda en el hero de celular
  var GOTA_MOVIL_OFF = 86;   // las dos que asoman
  var CORTE_MOVIL = 750;

  function suave(t) { return t < 0 ? 0 : t > 1 ? 1 : t * t * (3 - 2 * t); }
  function tramo(p, a, b) { return suave((p - a) / (b - a)); }
  function ventana(p, a, b, c, d) { return Math.min(tramo(p, a, b), 1 - tramo(p, c, d)); }

  var CLAVES = ['x', 'y', 'w', 'h', 'r', 'b', 'o'];
  function mezcla(u, v, t) {
    var s = {};
    for (var i = 0; i < CLAVES.length; i++) {
      var k = CLAVES[i];
      s[k] = u[k] + (v[k] - u[k]) * t;
    }
    return s;
  }

  function estadoDe(serie, p) {
    if (p <= BISAGRAS[0]) return serie[0];
    for (var i = 0; i < BISAGRAS.length - 1; i++) {
      if (p <= BISAGRAS[i + 1]) {
        return mezcla(serie[i], serie[i + 1], tramo(p, BISAGRAS[i], BISAGRAS[i + 1]));
      }
    }
    return serie[serie.length - 1];
  }

  function montar(raiz) {
    if (REDUCE || raiz.dataset.gaelaMontado === '1') return;
    raiz.dataset.gaelaMontado = '1';

    var pista = raiz.querySelector('.gaela-hilo__pista');
    var escena = raiz.querySelector('.gaela-hilo__escena');
    var gotas = raiz.querySelectorAll('.gaela-hilo__gota');
    var etiquetas = raiz.querySelectorAll('.gaela-hilo__etiqueta');
    var actos = raiz.querySelectorAll('.gaela-hilo__acto');
    var principios = raiz.querySelectorAll('.gaela-hilo__principio');
    var carril = raiz.querySelector('.gaela-hilo__carril');
    var tarjetas = raiz.querySelectorAll('.gaela-hilo__tarjeta');
    var bajo = raiz.querySelector('.gaela-hilo__bajo');
    var pastillas = raiz.querySelectorAll('.gaela-hilo__pastillas button');
    var flechas = raiz.querySelectorAll('.gaela-hilo__flechas button');
    var puntosActo = raiz.querySelectorAll('.gaela-hilo__actos i');
    var indicio = raiz.querySelector('.gaela-hilo__indicio');
    var carga = raiz.querySelector('.gaela-hilo__carga');
    var cargaBarra = carga ? carga.firstElementChild : null;
    var plan = raiz.querySelector('.gaela-hilo__plan');
    var puntosPlan = raiz.querySelector('.gaela-hilo__puntos');

    if (!pista || !escena || !gotas.length) return;

    var acto1 = raiz.querySelector('.gaela-hilo__acto--1');
    var acto2 = raiz.querySelector('.gaela-hilo__acto--2');
    var acto3 = raiz.querySelector('.gaela-hilo__acto--3');
    var acto4 = raiz.querySelector('.gaela-hilo__acto--4');
    var acto5 = raiz.querySelector('.gaela-hilo__acto--5');

    /* Los colores viven en los data-* del HTML, que a su vez salen de los
       tokens vía Liquid. Aquí no se escribe ni un color. */
    var PALETA = [];
    gotas.forEach(function (g) {
      PALETA.push({ bola: g.dataset.bola || '', hilo: g.dataset.hilo || '' });
    });

    var W = 0, H = 0, tope = 0, largo = 1, pedido = false;
    var pad = 0, util = 0, seg = 0;
    var movil = false;
    var activo = 1;              // qué plan manda en el carrusel del hero
    var avanceCarril = 0;
    var yRiel = 0, yBolas = 0;
    var ESTADOS = [];
    var primeraVez = true;

    function esMovil() { return W < CORTE_MOVIL; }

    function irAPlan(i) {
      activo = i;
      if (puntosPlan) {
        puntosPlan.querySelectorAll('button').forEach(function (b, j) {
          b.setAttribute('aria-pressed', String(j === i));
        });
      }
      if (plan) {
        var datos = raiz.querySelectorAll('.gaela-hilo__plan-dato');
        datos.forEach(function (d, j) { d.hidden = j !== i; });
      }
      calcular();
      pintar();
    }

    function calcular() {
      /* El margen se MIDE, no se parsea: el token está en rem y
         parseFloat('2rem') devuelve 2. El acto 2 lleva ese mismo margen en
         su `left`, así que su offsetLeft ya es el valor real en píxeles. */
      pad = acto2 ? acto2.offsetLeft : 24;
      util = W - pad * 2;
      seg = util / 3;
      movil = esMovil();

      // El riel se pega justo debajo del carrusel, midiendo su sitio real (D-050)
      if (acto3 && carril) {
        yRiel = acto3.offsetTop + carril.offsetTop + carril.offsetHeight + (movil ? 14 : 20);
        if (bajo) bajo.style.top = (yRiel + (movil ? 16 : 22)) + 'px';
        if (carga) {
          carga.style.left = pad + 'px';
          carga.style.width = util + 'px';
          carga.style.top = (yRiel - 1) + 'px';
        }
      }

      /* Hero de celular: la fila de bolitas cuelga del fondo REAL del titular,
         nunca de un porcentaje de pantalla, o acaba encima del texto. */
      if (movil && acto1 && plan && puntosPlan) {
        var finTitular = acto1.offsetTop + acto1.offsetHeight;
        yBolas = finTitular + 64 + GOTA_MOVIL_ON / 2;
        var yPlan = yBolas + GOTA_MOVIL_ON / 2 + 20;
        plan.style.top = yPlan + 'px';
        puntosPlan.style.top = (yPlan + plan.offsetHeight + 12) + 'px';
      }

      var anchoCol = movil ? util : (util - 34 * 2) / 3;

      ESTADOS = [];
      for (var i = 0; i < gotas.length; i++) {
        var disp = movil
          ? (i === activo
              ? { x: W * 0.50, y: yBolas, d: GOTA_MOVIL_ON }
              : { x: i < activo ? W * 0.06 : W * 0.94, y: yBolas, d: GOTA_MOVIL_OFF })
          : [{ x: W * 0.60, y: H * 0.22, d: 166 },
             { x: W * 0.68, y: H * 0.52, d: 200 },
             { x: W * 0.80, y: H * 0.16, d: 132 }][i];

        var col = principios[i];
        var yCol = acto2 && col ? acto2.offsetTop + col.offsetTop : H * 0.5;
        var xCol = movil ? pad : pad + i * (anchoCol + 34);

        var riel = { x: pad + i * seg + seg / 2, y: yRiel, w: seg, h: 2, r: 0, b: 0, o: 1 };

        /* Entrada al acto 4 = K: el hilo se guarda. Los tres tramos suben y
           se juntan en la línea del encabezado, de borde a borde. No aterriza
           sobre ninguna pieza del contenido, así que el acto 4 puede cambiar
           entero sin tocar esto. */
        var guardado = { x: (W / 3) * i + W / 6, y: 1, w: W / 3, h: 2, r: 0, b: 0, o: 1 };

        ESTADOS.push([
          { x: disp.x, y: disp.y, w: disp.d, h: disp.d, r: 50, b: movil ? 5 : 14,
            o: (movil && i !== activo) ? 0.4 : 0.92 },
          { x: xCol + anchoCol / 2, y: yCol, w: anchoCol, h: 2, r: 0, b: 0, o: 1 },
          riel,
          riel,
          guardado,
          cierre()
        ]);
      }
    }

    /* La gota única del cierre. En escritorio cabe holgada por encima del
       bloque centrado; en celular el bloque es más alto y ocupa casi toda la
       pantalla, así que la gota se coloca MIDIENDO dónde empieza el texto.
       Antes iba a un 30 % fijo y le caía encima. */
    function cierre() {
      var d = movil ? 88 : 150;
      var y = H * 0.30;
      if (movil && acto5) {
        // el bloque va centrado en su `top`, así que su borde superior real
        // está media altura por encima
        var arribaTexto = acto5.offsetTop - acto5.offsetHeight / 2;
        // y el suelo deja pasar el encabezado, que va pegado arriba
        y = Math.max(d / 2 + 70, arribaTexto - d / 2 - 24);
      }
      return { x: W / 2, y: y, w: d, h: d, r: 50, b: 16, o: 0.5 };
    }

    function medir() {
      /* Nunca fiarse de un solo ancho: si algo desborda, la sección puede
         medir más que la pantalla y las gotas se calculan para un ancho que
         no se ve. Se toma el menor de los dos. */
      W = Math.min(escena.clientWidth || Infinity, document.documentElement.clientWidth);
      H = window.innerHeight;
      escena.style.height = H + 'px';
      /* Cuántas pantallas de scroll dura la escena entera. A 7,5 la página se
         sentía a media velocidad: son 1,5 pantallas por acto y el dedo no
         llega. A 4,2 cada acto cuesta menos de una pantalla y el recorrido
         responde. Bajar más empieza a atropellar el acto 3, que tiene meseta. */
      pista.style.height = (H * 4.2) + 'px';
      tope = pista.getBoundingClientRect().top + window.scrollY;
      largo = Math.max(1, pista.offsetHeight - H);
      calcular();
      pintar();
    }

    function pintar() {
      var p = (window.scrollY - tope) / largo;
      p = p < 0 ? 0 : p > 1 ? 1 : p;

      var enRiel = p > 0.36 && p < 0.62;

      gotas.forEach(function (g, i) {
        var s = estadoDe(ESTADOS[i], p);
        g.style.width = s.w + 'px';
        g.style.height = s.h + 'px';
        g.style.transform = 'translate3d(' + (s.x - s.w / 2) + 'px,' + (s.y - s.h / 2) + 'px,0)';
        var pin = g.firstElementChild;
        pin.style.borderRadius = s.r + '%';
        pin.style.filter = 'blur(' + s.b + 'px)';
        // en el acto 3 cada tramo se enciende al llegar su producto
        pin.style.opacity = String(enRiel && avanceCarril < i - 0.35 ? 0.22 : s.o);
        // mientras es línea lleva el degradado del hilo; con K lo es hasta el cierre
        pin.style.background = (p > 0.16 && p < 0.88) ? PALETA[i].hilo : PALETA[i].bola;
      });

      var irse = tramo(p, 0.02, 0.10);
      etiquetas.forEach(function (e, i) {
        var q = ESTADOS[i][0];
        e.style.transform = 'translate3d(' + (q.x + q.w * 0.42) + 'px,' +
                            (q.y - 18 - 26 * irse) + 'px,0)';
        e.style.opacity = String(1 - irse);
      });

      if (movil && plan && puntosPlan) {
        plan.style.opacity = String(1 - irse);
        puntosPlan.style.opacity = String(1 - irse);
        puntosPlan.style.pointerEvents = irse < 0.4 ? 'auto' : 'none';
        raiz.classList.toggle('gaela-hilo--suave', !primeraVez && p < 0.05);
      }

      var visibles = [
        [acto1, 1 - tramo(p, 0.02, 0.11)],
        [acto2, ventana(p, 0.16, 0.24, 0.32, 0.39)],
        [acto3, ventana(p, 0.36, 0.44, 0.62, 0.68)],
        [acto4, ventana(p, 0.70, 0.77, 0.84, 0.88)],
        [acto5, tramo(p, 0.90, 0.96)]
      ];
      visibles.forEach(function (par) {
        var el = par[0], o = par[1];
        if (!el) return;
        el.style.opacity = String(o);
        var base = ((el === acto1 && !movil) || el === acto5) ? 'translateY(-50%) ' : '';
        el.style.transform = base + 'translate3d(0,' + (24 * (1 - o)) + 'px,0)';
        el.style.pointerEvents = o > 0.5 ? 'auto' : 'none';
      });

      tarjetas.forEach(function (t, i) {
        var o = ventana(p, 0.38 + i * 0.02, 0.48 + i * 0.02, 0.62, 0.67);
        t.style.opacity = String(o);
        t.style.transform = 'translate3d(0,' + (34 * (1 - o)) + 'px,0)';
      });

      if (bajo) {
        var ob = ventana(p, 0.46, 0.52, 0.62, 0.66);
        bajo.style.opacity = String(ob);
        bajo.style.pointerEvents = ob > 0.5 ? 'auto' : 'none';
      }

      if (carga) {
        carga.style.opacity = String(ventana(p, 0.39, 0.44, 0.62, 0.67));
        cargaBarra.style.transform = 'scaleX(' + tramo(p, 0.40, 0.62) + ')';
      }

      var cual = p < 0.15 ? 0 : p < 0.35 ? 1 : p < 0.68 ? 2 : p < 0.88 ? 3 : 4;
      puntosActo.forEach(function (n, i) { n.classList.toggle('esta', i === cual); });

      if (indicio) indicio.style.opacity = String(0.7 * (1 - tramo(p, 0.02, 0.12)));

      pedido = false;
    }

    /* ── el carrusel lateral del acto 3 ─────────────────────────────────── */
    function paso() {
      var t = tarjetas[0];
      if (!t) return 1;
      var estilo = getComputedStyle(t.parentElement);
      return t.offsetWidth + (parseFloat(estilo.columnGap) || 0);
    }

    if (carril) {
      carril.addEventListener('scroll', function () {
        avanceCarril = carril.scrollLeft / paso();
        var i = Math.round(avanceCarril);
        pastillas.forEach(function (b, j) { b.setAttribute('aria-pressed', String(j === i)); });
        flechas.forEach(function (b) {
          var d = Number(b.dataset.direccion);
          b.disabled = d < 0 ? i <= 0 : i >= tarjetas.length - 1;
        });
      }, { passive: true });

      flechas.forEach(function (b) {
        b.addEventListener('click', function () {
          carril.scrollBy({ left: Number(b.dataset.direccion) * paso(),
                            behavior: REDUCE ? 'auto' : 'smooth' });
        });
      });
      pastillas.forEach(function (b, i) {
        b.addEventListener('click', function () {
          carril.scrollTo({ left: i * paso(), behavior: REDUCE ? 'auto' : 'smooth' });
        });
      });
    }

    /* ── el carrusel de planes del hero, en celular ─────────────────────── */
    if (puntosPlan) {
      puntosPlan.querySelectorAll('button').forEach(function (b, i) {
        b.addEventListener('click', function () { irAPlan(i); });
      });
    }
    gotas.forEach(function (g, i) {
      g.addEventListener('click', function () { if (movil && i !== activo) irAPlan(i); });
    });

    /* Deslizar de lado en el hero para cambiar de plan.
       Solo mientras el hero está en pantalla, y solo si el gesto es
       claramente horizontal: si no, se tragaría el scroll vertical, que es
       lo que mueve la escena entera. */
    (function deslizarHero() {
      var x0 = 0, y0 = 0, siguiendo = false;

      escena.addEventListener('touchstart', function (e) {
        if (!movil || e.touches.length !== 1) return;
        if ((window.scrollY - tope) / largo > 0.05) return;   // ya salimos del hero
        x0 = e.touches[0].clientX;
        y0 = e.touches[0].clientY;
        siguiendo = true;
      }, { passive: true });

      escena.addEventListener('touchmove', function (e) {
        if (!siguiendo) return;
        var dx = e.touches[0].clientX - x0;
        var dy = e.touches[0].clientY - y0;
        if (Math.abs(dy) > Math.abs(dx)) { siguiendo = false; return; }  // es scroll
        if (Math.abs(dx) < 44) return;
        siguiendo = false;
        var destino = dx < 0 ? activo + 1 : activo - 1;
        if (destino >= 0 && destino < gotas.length) irAPlan(destino);
      }, { passive: true });

      escena.addEventListener('touchend', function () { siguiendo = false; }, { passive: true });
    })();


    addEventListener('scroll', function () {
      if (!pedido) { pedido = true; requestAnimationFrame(pintar); }
    }, { passive: true });

    var reMedir;
    addEventListener('resize', function () {
      clearTimeout(reMedir);
      reMedir = setTimeout(medir, 150);
    }, { passive: true });

    medir();
    irAPlan(activo);
    /* 'suave' anima el cambio de plan. Si ya está puesto en el primer pintado,
       las tres bolitas entran volando desde la esquina al cargar la página. */
    requestAnimationFrame(function () { primeraVez = false; });
  }

  function arrancar() {
    document.querySelectorAll('.gaela-hilo').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // El personalizador reinyecta la sección al editarla
  document.addEventListener('shopify:section:load', arrancar);
})();
